import { useAuthentication } from '@connected/api-client/hooks/use-authentication';
import { ScreenSizeProvider } from '@connected/ui/providers/screen-size';
import { RouterProvider } from '@tanstack/react-router';

import { logger } from '@/lib/logger';
import { queryClient } from '@/lib/query-client';
import { router } from '@/lib/router';

export function Providers() {
    const auth = useAuthentication();

    logger.info({
        system: 'Providers',
        message: 'Loading providers',
    });

    return (
        <ScreenSizeProvider>
            <RouterProvider
                router={router}
                context={{ queryClient, ...auth }}
            />
        </ScreenSizeProvider>
    );
}
